document.addEventListener('DOMContentLoaded', () => {
  const sortWrapper = document.getElementById('tpSortSelect');
  const trigger = document.getElementById('tpSortTrigger');
  const triggerText = document.getElementById('tpSortTriggerText');
  const list = document.getElementById('tpSortList');
  const grid = document.getElementById('tpCatalogueGrid');
  if (!sortWrapper || !trigger || !list || !grid) return;

  const options = Array.from(list.querySelectorAll('.tp-sort-select__option'));
  function closeList() { list.hidden = true; trigger.setAttribute('aria-expanded', 'false'); }
  function openList() { list.hidden = false; trigger.setAttribute('aria-expanded', 'true'); const selected = list.querySelector('.is-selected') || options[0]; if (selected) selected.focus(); }
  trigger.addEventListener('click', () => { if (list.hidden) openList(); else closeList(); });
  document.addEventListener('click', (e) => { if (!sortWrapper.contains(e.target)) closeList(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !list.hidden) { closeList(); trigger.focus(); } });
  options.forEach((opt, index) => {
    opt.addEventListener('click', () => selectOption(opt));
    opt.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); (options[index + 1] || options[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (options[index - 1] || options[options.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(opt); }
    });
  });
  function selectOption(opt) {
    if (opt.classList.contains('is-selected')) { closeList(); trigger.focus(); return; }
    options.forEach((o) => { o.classList.remove('is-selected'); o.setAttribute('aria-selected', 'false'); });
    opt.classList.add('is-selected'); opt.setAttribute('aria-selected', 'true');
    triggerText.textContent = opt.textContent.trim();
    closeList(); trigger.focus();
    performSort(opt.dataset.value);
  }
  function getSectionId() { const wrapper = grid.closest('[id^="shopify-section-"]'); return wrapper ? wrapper.id.replace('shopify-section-', '') : null; }
  async function performSort(sortValue) {
    const sectionId = getSectionId();
    if (!sectionId) return;
    const fetchUrl = new URL(window.location.href);
    fetchUrl.searchParams.set('sort_by', sortValue);
    fetchUrl.searchParams.set('section_id', sectionId);
    let html;
    try { const response = await fetch(fetchUrl.toString()); html = await response.text(); }
    catch (err) { const fallbackUrl = new URL(window.location.href); fallbackUrl.searchParams.set('sort_by', sortValue); window.location.href = fallbackUrl.toString(); return; }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = doc.getElementById('tpCatalogueGrid');
    if (!newGrid) return;
    grid.innerHTML = newGrid.innerHTML;
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.set('sort_by', sortValue);
    window.history.pushState({}, '', cleanUrl.toString());
    /* Reinitialise les rangees horizontales (fleches) apres re-rendu */
    document.dispatchEvent(new CustomEvent('tp:grid:updated'));
  }
});

/* ============================================================
   Quick Add catalogue — bouton "+" sur les cartes produit.
   - Delegation d'evenements sur document (survit au tri et aux rangees).
   - Modes : direct (1 clic), picker (pastilles couleur), panel (produit
     1 variante + supplement : panneau compact avec bouton Ajouter).
   - Supplement (mini-bloc) : propose, JAMAIS ajoute sans case cochee ;
     envoye dans la MEME requete que le produit (ajout atomique).
   - Etats : idle -> loading -> added (« Ajoute » UNIQUEMENT apres reponse
     OK du panier) | error -> idle. aria-live #tpQuickAddLive.
   ============================================================ */
(function () {
  if (window.__tpQuickAddBound) return;
  window.__tpQuickAddBound = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ADDED_MS = 1600;
  var ERROR_MS = 2200;
  var FLY_MS = 650;

  function gridLabels() { var grid = document.getElementById('tpCatalogueGrid'); return grid ? grid.dataset : {}; }
  function setState(btn, state, text) {
    btn.dataset.state = state;
    btn.classList.toggle('is-loading', state === 'loading');
    btn.classList.toggle('is-added', state === 'added');
    btn.classList.toggle('is-error', state === 'error');
    var label = btn.querySelector('.tp-quick-add__label');
    if (label) label.textContent = text || '';
    var busy = state === 'loading';
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    /* Inactif via aria-disabled (pas disabled) : le bouton garde le focus
       clavier pendant l'envoi et l'etat « Ajoute » (D4) ; les clics sont
       ignores par handleQuickAdd tant que l'etat est loading / added. */
    if (busy || state === 'added') btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
  }
  function announce(message) { var live = document.getElementById('tpQuickAddLive'); if (!live) return; live.textContent = ''; window.setTimeout(function () { live.textContent = message; }, 30); }
  function closeAllPickers(restoreFocus) {
    document.querySelectorAll('[data-quick-pick]:not([hidden])').forEach(function (pick) {
      pick.hidden = true;
      var actions = pick.closest('.tp-product-card__actions');
      var btn = actions ? actions.querySelector('[data-quick-add]') : null;
      if (btn) { btn.setAttribute('aria-expanded', 'false'); if (restoreFocus) btn.focus(); }
    });
  }

  function flyToCart(btn, imageUrl, done) {
    var target = document.getElementById('tpCartIconBtn');
    if (reduced || !target || !imageUrl || typeof document.body.animate !== 'function') { done(); return; }
    var card = btn.closest('.tp-product-card');
    var source = (card && card.querySelector('.tp-product-card__img')) || btn;
    var from = source.getBoundingClientRect(); var to = target.getBoundingClientRect(); var size = 56;
    var startX = from.left + from.width / 2 - size / 2, startY = from.top + from.height / 2 - size / 2;
    var endX = to.left + to.width / 2 - size / 2, endY = to.top + to.height / 2 - size / 2;
    var midX = (startX + endX) / 2, midY = Math.min(startY, endY) - 70;
    var thumb = document.createElement('div');
    thumb.className = 'tp-fly-thumb'; thumb.setAttribute('aria-hidden', 'true');
    thumb.style.width = size + 'px'; thumb.style.height = size + 'px';
    thumb.style.transform = 'translate(' + startX + 'px, ' + startY + 'px) scale(1)';
    var img = document.createElement('img'); img.src = imageUrl; img.alt = ''; thumb.appendChild(img);
    document.body.appendChild(thumb);
    var finished = false;
    function finish() { if (finished) return; finished = true; thumb.remove(); done(); }
    var animation = thumb.animate([
      { transform: 'translate(' + startX + 'px, ' + startY + 'px) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + midX + 'px, ' + midY + 'px) scale(0.72)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + endX + 'px, ' + endY + 'px) scale(0.28)', opacity: 0.15, offset: 1 }
    ], { duration: FLY_MS, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
    animation.onfinish = finish; animation.oncancel = finish;
    window.setTimeout(finish, FLY_MS + 250);
  }

  function selectedSupplements(pick) {
    var items = []; var names = [];
    if (!pick) return { items: items, names: names };
    pick.querySelectorAll('[data-tp-qa-supp]:checked').forEach(function (input) {
      var id = parseInt(input.value, 10);
      if (id) { items.push({ id: id, quantity: 1 }); names.push(input.dataset.tpQaSuppName || ''); }
    });
    return { items: items, names: names };
  }

  function addItems(btn, items, imageUrl, extraNames) {
    if (!items.length || !window.ToudouCart || typeof window.ToudouCart.addToCart !== 'function') return;
    var labels = gridLabels();
    setState(btn, 'loading');
    window.ToudouCart.addToCart(items, 1, { openDrawer: false, bounce: false })
      .then(function () {
        setState(btn, 'added', labels.qaAdded || '');
        var msg = (labels.qaLiveAdded || '') + ' ' + (btn.dataset.productTitle || '');
        if (extraNames && extraNames.length) msg += ' + ' + extraNames.join(', ');
        announce(msg);
        flyToCart(btn, imageUrl, function () { if (!reduced && window.ToudouCart.bounceCartIcon) window.ToudouCart.bounceCartIcon(); });
        var pick = btn.closest('.tp-product-card__actions'); pick = pick ? pick.querySelector('[data-quick-pick]') : null;
        if (pick) pick.querySelectorAll('[data-tp-qa-supp]').forEach(function (i) { i.checked = false; });
        window.setTimeout(function () { if (btn.isConnected) setState(btn, 'idle'); }, ADDED_MS);
      })
      .catch(function (err) {
        if (window.console) console.warn('[ToudouPet] Quick Add refusé :', err && err.message ? err.message : err);
        setState(btn, 'error', labels.qaRetry || '');
        announce(labels.qaRetry || '');
        window.setTimeout(function () { if (btn.isConnected && btn.dataset.state === 'error') setState(btn, 'idle'); }, ERROR_MS);
      });
  }

  function handleQuickAdd(btn) {
    var state = btn.dataset.state;
    if (state === 'loading' || state === 'added') return;
    if (btn.dataset.mode === 'picker' || btn.dataset.mode === 'panel') {
      var actions = btn.closest('.tp-product-card__actions');
      var pick = actions ? actions.querySelector('[data-quick-pick]') : null;
      if (!pick) return;
      var willOpen = pick.hidden;
      closeAllPickers();
      if (willOpen) {
        pick.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var first = pick.querySelector('[data-quick-pick-variant]:not(:disabled)');
        if (first) first.focus();
      }
      return;
    }
    addItems(btn, [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }], btn.dataset.image, []);
  }

  function handlePick(target) {
    var actions = target.closest('.tp-product-card__actions');
    var btn = actions ? actions.querySelector('[data-quick-add]') : null;
    var pick = actions ? actions.querySelector('[data-quick-pick]') : null;
    if (!btn) return;
    var supp = selectedSupplements(pick);
    var items = [{ id: parseInt(target.dataset.quickPickVariant, 10), quantity: 1 }].concat(supp.items);
    /* Le choix va etre masque : si le focus y etait, il revient au bouton + (D4). */
    closeAllPickers(!!pick && pick.contains(document.activeElement));
    addItems(btn, items, target.dataset.image || btn.dataset.image, supp.names);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (btn) { e.preventDefault(); handleQuickAdd(btn); return; }
    var pickTarget = e.target.closest('[data-quick-pick-variant]');
    if (pickTarget) { e.preventDefault(); handlePick(pickTarget); return; }
    if (!e.target.closest('[data-quick-pick]')) closeAllPickers(false);
  });
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-tp-qa-supp-variant]');
    if (!radio) return;
    var card = radio.closest('[data-tp-qa-supp-card]');
    if (!card) return;
    var input = card.querySelector('[data-tp-qa-supp]');
    var price = card.querySelector('[data-tp-qa-supp-price]');
    if (input) input.value = radio.value;
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPickers(true); });
})();